const e = "上昇番号", n = "下降番号", t = {
  increment: e,
  decrement: n
};
export {
  n as decrement,
  t as default,
  e as increment
};
